// src/theme/theme.ts
import { createTheme } from "@mui/material/styles";

// 🔹 Extend MUI's Background type to support custom keys
declare module "@mui/material/styles" {
  interface TypeBackground {
    navbar?: string;
    sidebar?: string;
    footer?: string;
    section?: string;
  }
}

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FFC923",
    },
    secondary: {
      main: "#080018",
    },
    error: {
      main: "#d32f2f",
    },
    background: {
      default: "#F6F8FB",
      paper: "#ffffff",
      navbar: "#f0f0f0",
      sidebar: "#080018",
      footer: "#fafafa",
      section: "#f9f9f9",
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#555555",
      disabled: "#9e9e9e",
    },
  },
  typography: {
    fontFamily: "'DM Sans', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "primary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.getContrastText(theme.palette.primary.main),
            border: '1px solid #373A45',
            textTransform: "capitalize",
            "&:hover": {
              // backgroundColor: "#115293",
            },
          }),
        },
        {
          props: { variant: "secondary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.getContrastText(theme.palette.secondary.main),
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: theme.palette.secondary.main,
            },
            '&.Mui-disabled': {
              opacity: 1,
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.getContrastText(theme.palette.secondary.main),
            }
          }),
        },
        {
          props: { variant: "text" },
          style: ({ theme }) => ({
            backgroundColor: "#F6F8FB",
            color: "#373A45",
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.background.paper,
            },
          }),
        },
        {
          props: { variant: "danger" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: "#9a0007",
            },
          }),
        }
      ],
    },
    // 🔹 Add TextField (OutlinedInput) theme overrides
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          height: 40,
          "& fieldset": {
            border: "0.5px solid #CECECE !important",
          },
          "&:hover fieldset": {
            border: "0.5px solid #CECECE !important",
          },
          "&.Mui-focused fieldset": {
            border: "0.5px solid #CECECE !important", // no blue border
          },
        },
        input: {
          padding: "8px 12px", // adjust inner text padding
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          color: "#555555",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          // color: theme.palette.primary.main, // default color
        }),
      },

    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          background: "#FFF",
          boxShadow: "none",
          padding: "12px 16px"
        },
      },
    },

  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#90caf9",
    },
    secondary: {
      main: "#ce93d8",
    },
    error: {
      main: "#f44336",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
      navbar: "#1a1a1a",
      sidebar: "#181818",
      footer: "#161616",
      section: "#1c1c1c",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0b0b0",
      disabled: "#6d6d6d",
    },
  },
  typography: {
    fontFamily: "'DM Sans', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "primary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
            textTransform: "capitalize",
            height: '40px !important',
            "&:hover": {
              backgroundColor: "#64b5f6",
            },
          }),
        },
        {
          props: { variant: "secondary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.getContrastText(theme.palette.secondary.main),
            textTransform: "capitalize",
            height: '40px !important',
            "&:hover": {
              backgroundColor: "#ba68c8",
            },
          }),
        },
        {
          props: { variant: "danger" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.error.main,
            height: '40px !important',
            color: theme.palette.getContrastText(theme.palette.error.main),
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: "#ef5350",
            },
          }),
        },
      ],
    },
  },
});
